// OidcProviderWrapper.tsx
import React, { lazy, Suspense, useEffect, useState, ReactNode } from 'react'

const OidcProviderClientSide = lazy(() => import('./OidcProviderClientSide.tsx')) // Stellen Sie sicher, dass der Pfad korrekt ist

interface OidcProviderWrapperProps {
  children: ReactNode
}

const OidcProviderWrapper: React.FC<OidcProviderWrapperProps> = ({ children }) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <div>
      {isClient ? (
        <Suspense fallback={<></>}>
          <OidcProviderClientSide>{children}</OidcProviderClientSide>
        </Suspense>
      ) : (
        <></> // Dies wird während des SSR angezeigt
      )}
    </div>
  )
}

export default OidcProviderWrapper
